import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const UserFeedback = React.lazy(() =>
    import('../UserFeedback')
);
const userFeedbackRoutesRegistry = [
    {
        path: PAGE_URL.USER_FEEDBACK_PAGE,
        element: <UserFeedback />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userFeedbackRoutesRegistry;
